import { render } from "./trader-performance.vue?vue&type=template&id=80cb9f8c"
import script from "./trader-performance.vue?vue&type=script&lang=js"
export * from "./trader-performance.vue?vue&type=script&lang=js"

import "./trader-performance.vue?vue&type=style&index=0&id=80cb9f8c&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__